import { render, staticRenderFns } from "./LabelDropdownItem.vue?vue&type=template&id=cd75efb2&scoped=true&"
import script from "./LabelDropdownItem.vue?vue&type=script&lang=js&"
export * from "./LabelDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./LabelDropdownItem.vue?vue&type=style&index=0&id=cd75efb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd75efb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd75efb2')) {
      api.createRecord('cd75efb2', component.options)
    } else {
      api.reload('cd75efb2', component.options)
    }
    module.hot.accept("./LabelDropdownItem.vue?vue&type=template&id=cd75efb2&scoped=true&", function () {
      api.rerender('cd75efb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shared/components/ui/label/LabelDropdownItem.vue"
export default component.exports